import { useColorThemeContext } from '~/providers/ColorThemeProvider/ColorThemeProvider.context';
import { neutralPalette } from '~/styles/constants.css';

import { brandShades } from './Illustration.css';

export const useIllustrationShades = () => {
  const { colorTheme } = useColorThemeContext();

  return { ...brandShades[colorTheme], black: neutralPalette.gray.$900, white: neutralPalette.white };
};
